enum BuilderSteps {
  BRAND = 'brands',
  CAMPAIGN = 'campaign',
  BRIEF = 'brief',
  BUDGET = 'budget',
  SUBMIT = 'submit',
}

export { BuilderSteps }
